import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { VideoTutorial } from "../start/start.interface";

@Component({
  selector: "app-video-dialog",
  templateUrl: "./video-dialog.component.html",
  styleUrls: ["./video-dialog.component.scss"],
  standalone: false,
})
export class VideoDialogComponent implements OnInit {
  video: VideoTutorial;
  safeVideoUrl: SafeResourceUrl;

  constructor(
    public dialogRef: MatDialogRef<VideoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { video: VideoTutorial },
    private sanitizer: DomSanitizer,
  ) {
    this.video = data.video;
  }

  ngOnInit(): void {
    this.safeVideoUrl = this.getSafeVideoUrl(this.video.youtubeUrl);
  }

  onClose(): void {
    this.dialogRef.close();
  }

  private getSafeVideoUrl(url: string | undefined): SafeResourceUrl {
    if (!url) {
      return "";
    }

    try {
      let videoId = "";
      if (url.includes("v=")) {
        videoId = url.split("v=")[1]?.split("&")[0] || "";
      } else if (url.includes("youtu.be/")) {
        videoId = url.split("youtu.be/")[1]?.split("?")[0] || "";
      }

      if (!videoId) {
        return "";
      }

      const embedUrl = `https://www.youtube.com/embed/${videoId}?rel=0&showinfo=0`;
      return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
    } catch {
      return "";
    }
  }
}
